import { JSONObject } from "../../types";

export function getAppFromSpaWrapper() {
  let application = null;
  const appContainer = document.getElementById("vacv-spa-container");
  if (appContainer) {
    application = appContainer.querySelector("#app");
  }
  return application;
}

export function getConfig() {
  const app = getAppFromSpaWrapper();
  if (app?.dataset?.vars) {
    return JSON.parse(app.dataset.vars);
  }
  return null;
}

export const config = getConfig();

export function getEnvVarFromConfig(cfg: JSONObject, name: string) {
  if (cfg && name in cfg) {
    return cfg[name];
  } else {
    return import.meta.env[name];
  }
}

export function getEnvVar(name: string) {
  return getEnvVarFromConfig(config, name);
}
